import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'semantic-ui-react';
import activities from 'constants/activities';

const DefaultFilter = ({
  activity,
  category,
  form,
  handleChange,
  searchName,
  types,
  typeName,
}) => {
  if (!activity) {
    return (
      <Form.Field
        id="input-name"
        name="search"
        control={Input}
        label={searchName}
        placeholder={`${searchName}...`}
        onChange={handleChange}
      />
    );
  }

  const getFieldName = () => {
    switch (activity) {
      case activities.GROUP:
        return category === 'transactions' ? 'purpose' : 'resource';
      case activities.MEMBER:
        return 'purpose';
      default:
        return 'filter';
    }
  };

  const getDefaultValue = () => {
    switch (activity) {
      case activities.GROUP:
        return category === 'transactions'
          ? form.type
          : form.resource;
      case activities.MEMBER:
        return form.purpose;
      default:
        return form.filter;
    }
  };

  const fieldName = getFieldName();

  return (
    <Form.Field
      name={fieldName}
      control={Select}
      fluid
      search
      selection
      defaultValue={getDefaultValue()}
      options={types}
      label={typeName}
      placeholder="-All-"
      onChange={(e, { name, value }) => {
        if (name === 'purpose') {
          return handleChange(e, { name, value: [value] });
        }
        handleChange(e, { name, value });
      }}
    />
  );
};

DefaultFilter.defaultProps = {
  activity: null,
  searchName: 'Name',
};

DefaultFilter.propTypes = {
  activity: PropTypes.string,
  category: PropTypes.string.isRequired,
  form: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  searchName: PropTypes.string,
  types: PropTypes.instanceOf(Array).isRequired,
  typeName: PropTypes.string.isRequired,
};

export default DefaultFilter;
